
import React from 'react';

function TopicsBox({topics}) {
  return (
    <div 
      className="relative flex flex-col justify-center items-center font-custom p-2 rounded-full" 
    >
      <div className="absolute bg-white opacity-20 rounded-3xl"></div> 
      
      <div className="relative flex flex-col md:flex-row items-center justify-center w-full">
            <div className="flex flex-wrap justify-center gap-8">
                {topics && topics.map((topic, idx) => (
                  <div key={idx} className="flex flex-col items-center">
                    {topic.icon && <img src={topic.icon} alt={topic.title} className="w-6 h-6 mb-1" />}
                    <span className="text-white text-2xl font-bold">{topic.value}</span> 
                  </div>
                ))}
            </div>
          </div>
    </div>
  );
}

export default TopicsBox;